import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ticketsGoOnSaleComponentMessage } from '../../checkout/selectors/event'

class TicketsGoOnSale extends Component {
    render() {
        if (!this.props.statusMessage) {
            return null;
        }
        return(
            <div className="event-details__sale-status">{this.props.statusMessage}</div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        statusMessage: ticketsGoOnSaleComponentMessage(state),
    }
}

export default connect(mapStateToProps)(TicketsGoOnSale)
